import React, { useEffect, useState } from 'react';
import { Logo } from './ui/Logo';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'How It Works',
    id: 'how-it-works'
  }, {
    name: 'Platform',
    id: 'platform'
  }, {
    name: 'Use Cases',
    id: 'use-cases'
  }, {
    name: 'Team',
    id: 'team'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-hubble-bg/90 backdrop-blur-md border-b border-hubble-border py-3' : 'bg-transparent py-5'}`} data-id="element-78">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-79">
        <Logo data-id="element-80" />

        <nav className="hidden md:flex items-center gap-8" data-id="element-81">
          {navLinks.map(link => <a key={link.id} href={`#${link.id}`} onClick={e => scrollToSection(e, link.id)} className="font-body text-sm text-hubble-body hover:text-hubble-text transition-colors" data-id="element-82">
              {link.name}
            </a>)}
        </nav>

        <Button variant="primary" size="sm" onClick={() => window.open('https://calendly.com/prabha-hubble/30min?month=2026-04', '_blank')} data-id="element-83">
          Book Demo
        </Button>
      </div>
    </header>;
}